import { render, staticRenderFns } from "./handpickGroupList.vue?vue&type=template&id=1cd8c106&scoped=true&"
import script from "./handpickGroupList.vue?vue&type=script&lang=js&"
export * from "./handpickGroupList.vue?vue&type=script&lang=js&"
import style0 from "./handpickGroupList.vue?vue&type=style&index=0&id=1cd8c106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8c106",
  null
  
)

export default component.exports